<template>
  <div class="app">
    <vue-progress-bar></vue-progress-bar>
    <core-header/>
    <div class="app-body">
      <core-sidebar :navItems="nav"/>
      <main class="main">
        <core-breadcrumb />

        <div class="container-fluid alpha omega">
          <router-view></router-view>
        </div>
      </main>
      <core-aside/>
    </div>
    <!-- <core-footer/> -->
  </div>
</template>

<script>
  import nav from '@/_nav'
  
  export default {
    data () {
      return {
        nav: nav.items
      }
    },
    computed: {
      name () {
        return this.$route.name
      },

      list () {
        return this.$route.matched
      }
    }
  }
</script>

<style lang="sass">
  html, body
    height: 100%;
</style>



// WEBPACK FOOTER //
// src/components/containers/ContainerDefault.vue